<template>
    <div id="admin">
        <nav id="admin-navigation">
            <router-link to="/">POČETNA</router-link>
            <router-link to="/admin/users">KORISNICI</router-link>
            <router-link to="/admin/companies">TVRTKE</router-link>
            <router-link to="/admin/events">DOGAĐAJI</router-link>
            <router-link to="/admin/venues">PROSTORIJE</router-link>
            <router-link to="/admin/achievements">ACHIEVEMENTI</router-link>
            <router-link to="/admin/achievement-codes">ACHIEVEMENT KODOVI</router-link>
            <router-link to="/admin/survey-questions">PITANJA</router-link>
            <button class="button" v-on:click="logout()">ODJAVA</button>
        </nav>
        <router-view />
    </div>
</template>

<script>
    export default {
        name: 'Admin',
        methods: {
            logout: function() {
              localStorage.removeItem('token');
              this.$router.push('/');
          }
        }
    }
</script>

<style>
    body {
        margin: 0;
    }

    #admin > div:nth-child(2) {
        padding: 0 20px;
    }

    #admin-navigation {
        display: flex;
        flex-wrap: wrap;
        background-color: #30cec1;
        padding: 15px 10px 0 10px;
        margin-bottom: 20px;
    }

    #admin-navigation a {
        font-size: 18px;
        font-weight: 700;
        margin-right: 10px;
        text-decoration: none;
        color: white;
        border-bottom: 5px solid transparent;
        padding-bottom: 5px;
    }

    #admin-navigation a:hover,
    #admin-navigation a.router-link-exact-active {
        border-bottom: 5px solid white;
    }

    #admin-navigation button {
        margin-left: auto;
        position: relative;
        top: -10px;
    }

    .modaladmin,
    .modaladmin .close-modaladmin {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: rgb(0,0,0);
        background-color: rgba(0,0,0,0.4);
    }

    .modaladmin-content {
        padding: 10px;
        z-index: 1;
        border-radius: 10px;
        background-color: white;
    }

    .modaladmin-content div {
        height: auto;
        margin-top: 10px;
    }

    .modaladmin-content div input {
        margin-left: 10px;
        float: right;
        width: 200px;
    }

    .modaladmin-content .button,
    .modaladmin-footer {
        margin-top: 10px;
        float: right;
    }

    .modaladmin-footer button {
        margin-right: 10px;
        padding: 5px;
    }
</style>